module.exports = __webpack_public_path__ + "7a88dea2bc2eba97a940fe21e96a43d0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-3.png
// module id = 1474
// module chunks = 0